// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"79f5b329","405":"55ac5848","530":"cfbc2269","552":"f239f448","787":"2c1cee2b"}[chunkId] + ".chunk.js";
};